import { combineReducers } from 'redux';
import damageViewer from './damageViewer';

export { getImages, getImage } from './damageViewer';

export default combineReducers({
  damageViewer,
});
